
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13429',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13429",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1058",
  "client-types": "static-1.507",
  "data-fetching-client": "static-1.10070",
  "foundations-components": "static-1.8670",
  "foundations-components-legacy": "static-1.1695",
  "foundations-theming": "static-1.4905",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.92",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8462",
  "hub-http-shared-msw-handlers": "static-1.10819",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11916",
  "I18n": "static-7.1696",
  "jasmine-runner": "static-1.6873",
  "marketplace-discovery-studio-lib": "static-1.824",
  "marketplace-storefront-base": "static-1.13492",
  "quartz": "static-1.7597",
  "react-dlb": "static-1.92",
  "react-rhumb": "static-1.17157",
  "reactive-variable-buffer-atom": "static-1.3275",
  "reporting-testing-lib": "static-1.11139",
  "reselect": "static-3.15",
  "settings-ui-lib": "static-1.12954",
  "SharedI18nStrings": "static-1.186",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7779",
  "ui-addon-i18n": "static-1.11570",
  "ui-addon-react-router-dom": "static-1.9953",
  "unified-auth": "static-1.1148",
  "unified-auth-core-lib": "static-1.1430",
  "usage-tracker": "static-1.7738",
  "usage-tracker-core": "static-1.7588",
  "customer-data-property-utils": "static-1.8468",
  "hub-http": "static-1.6633",
  "integrations-lib": "static-1.17314",
  "marketplace-ui-common": "static-1.20967",
  "marketplace-ui-install": "static-1.953",
  "property-management-iframe": "static-1.14367",
  "quartz-config": "static-1.1375",
  "quartz-core": "static-1.6816",
  "quartz-routing": "static-1.1027",
  "quick-fetch": "static-1.4199",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5094",
  "ts-schema": "static-1.4369",
  "ui-universal-auth": "static-1.9634",
  "UIComponents": "static-3.8862",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3874",
  "quartz-webpack": "static-1.3821",
  "bend-plugin-quartz-routing": "static-1.675",
  "ai-components-ui-library": "static-1.9936",
  "codemirror": "static-5.105",
  "foundations-assets": "static-1.5308",
  "pulse": "static-1.1065",
  "react-codemirror": "static-1.11064",
  "ui-extensions-preview-lib": "static-1.844",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4939",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2621",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9848",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.94",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5631",
  "react-virtualized": "static-2.111",
  "StyleGuideUI": "static-3.514",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2967",
  "ui-fonts": "static-1.1178",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3388",
  "foundations-theming-base": "static-1.3890",
  "stylex": "static-1.45",
  "HeadJS": "static-2.815",
  "hs-test-utils-bend-plugin": "static-1.3573",
  "msw": "static-1.102",
  "msw-config": "static-1.23",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4732",
  "ui-addon-video-player": "static-1.9057",
  "ai-rendering-library": "static-1.11320",
  "chirp-fetch": "static-1.2325",
  "connections-embed-lib": "static-1.1672",
  "copilot-toolkit": "static-1.12059",
  "feedback-loader": "static-1.29986",
  "laboratory-lib": "static-3.7573",
  "marketplace-embed": "static-1.23116",
  "marketplace-ui-details": "static-1.10862",
  "marketplace-ui-reviews": "static-1.20922",
  "marketplace-ui-tracking": "static-1.15137",
  "sanitize-text": "static-1.8580",
  "usage-tracker-multi": "static-1.6152",
  "usage-tracker-session-replay": "static-1.5424",
  "wootric-nps": "static-1.7270",
  "quartz-head": "static-1.1262",
  "web-vitals": "static-1.18",
  "apollo-link-hub-http": "static-2.5022",
  "immer": "static-1.104",
  "immerable": "static-1.4565",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2788",
  "reporting-data": "static-1.69206",
  "cssUtils": "static-1.1046",
  "flux-actions": "static-1.380",
  "react-colorpicker": "static-2.10636",
  "react-dnd-compat": "static-1.5034",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10795",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7728",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19499",
  "storybook-react": "static-1.43",
  "trellis-story-utils": "static-1.4926",
  "foundations-components-test-utils": "static-1.6153",
  "quartz-i18n": "static-1.1272",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.676",
  "ads-unified-auth-lib": "static-1.1783",
  "custom-vendor-connection-lib": "static-1.198",
  "google-sheets-integration-lib": "static-1.1244",
  "microsoft-drive-auth-lib": "static-1.405",
  "surveymonkey-integration-lib": "static-1.772",
  "slack-ui-library": "static-1.10821",
  "fsm": "static-1.4179",
  "customer-data-objects": "static-1.8117",
  "property-translator": "static-1.5803",
  "hs-locale-management": "static-1.368",
  "frontend-preferences-client": "static-1.8342",
  "hs-promise-utils": "static-1.6013",
  "hubspot-apollo-client": "static-1.5301",
  "integrations-error-boundary-lib": "static-1.14729",
  "integrations-tracking-lib": "static-1.6035",
  "native-integrations-shared-strings": "static-1.8186",
  "sanitize": "static-1.4897",
  "superstore": "static-1.5182",
  "ui-shepherd-react": "static-3.10698",
  "ai-settings-ui-library": "static-1.8504",
  "hub-http-janus": "static-1.900",
  "hubspotter-http": "static-1.4936",
  "immutable-less": "static-1.5074",
  "marketplace-ui-client-types": "static-1.18374",
  "nav-meta": "static-1.30713",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18515",
  "ui-product-approvals-common": "static-1.1449",
  "ai-studio-lib": "static-1.12660",
  "hubspot-prosemirror": "static-1.19190",
  "integrations-reconnect-lib": "static-1.645",
  "ui-addon-iframeable": "static-1.9500",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-product-approvals": "static-1.29554",
  "ui-tool-access": "static-1.10579",
  "inbound-db-properties-service-client": "static-1.4116",
  "property-management-common": "static-1.6655",
  "opentelemetry-fe-types": "static-1.212",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.598",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.587",
  "quartz-auth": "static-1.1272",
  "quartz-test": "static-1.1272",
  "quartz-tracking": "static-1.976",
  "trellis-components": "static-1.2986",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.504",
  "HubStyle": "static-2.12223",
  "bender-build-tools": "static-1.3518",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23553",
  "ContentUtils": "static-1.69356",
  "customer-data-objects-ui-components": "static-1.13454",
  "sassPrefix": "static-1.312",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.568",
  "batch-promise": "static-1.1970",
  "event-emitter": "static-1.1383",
  "fast-json-patch": "static-1.73",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5860",
  "magpie-types": "static-1.5320",
  "stylex-utils": "static-1.164",
  "trellis-theming": "static-1.1409",
  "avatar-components": "static-1.2907",
  "breeze-engine-core": "static-1.1300",
  "breeze-onboarding-components": "static-1.971",
  "customer-data-filters-ui": "static-1.41242",
  "customer-data-reference-ui-components": "static-1.13591",
  "data-integrations-breeze": "static-1.212",
  "embedded-academy-lib": "static-1.15869",
  "ExportDialog": "static-6.10795",
  "global-styles-ai-lib": "static-1.408",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.819",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42282",
  "reporting-snowflake": "static-1.57822",
  "reporting-ui-components": "static-2.66475",
  "reporting-visualizations": "static-1.61280",
  "trial-components-library": "static-1.14299",
  "ui-addon-teams": "static-1.21969",
  "upgrade-components-lib": "static-1.662",
  "navigation-components": "static-1.19076",
  "breeze-engine-lib": "static-1.2022",
  "simple-logging-lib": "static-1.3475",
  "nudge-client-utils": "static-1.3333",
  "fail-safe": "static-1.377",
  "app-governance-lib": "static-1.2596",
  "developer-experience-shared-components": "static-1.10962",
  "purchase-motions-components": "static-1.6571",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10648",
  "usage-tracker-anonymous": "static-1.6155",
  "usage-tracker-public": "static-1.7549",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3746",
  "persist-promise": "static-1.4127",
  "reference-resolvers": "static-1.8601",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4339",
  "hubspot-apollo-cache": "static-1.760",
  "universal-page-editor-lib": "static-1.3433",
  "final-form": "static-1.82",
  "redux-toolkit": "static-1.81",
  "simple-data-table": "static-1.3743",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6876",
  "ui-addon-draggable": "static-3.5171",
  "content-assistance-lib": "static-1.8351",
  "content-media-capture": "static-1.5691",
  "customer-data-ui-utilities": "static-1.10257",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24756",
  "growth-payments-core": "static-1.26411",
  "knowledge-content-types": "static-1.8708",
  "PatternValidationJS": "static-1.3310",
  "payment-link-components": "static-1.24356",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20480",
  "ui-addon-emoji-picker": "static-1.10290",
  "ui-business-units-lib": "static-1.9518",
  "video-components-external": "static-1.12343",
  "video-data-lib": "static-1.36001",
  "navigation-messaging": "static-1.8403",
  "collaboration-sidebar": "static-1.58958",
  "trellis-ext-dnd": "static-1.467",
  "crm-component-utils": "static-1.40073",
  "crm-properties-common-lib": "static-1.6312",
  "customer-data-properties": "static-1.52903",
  "external-options-client-types": "static-1.4417",
  "framework-data-schema-resolvers": "static-1.7315",
  "property-value-citations": "static-1.3517",
  "reference-resolvers-lite": "static-1.8529",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.123",
  "hubspotter-http-shared-msw-handlers": "static-1.10817",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "cms-field-types": "static-1.5236",
  "content-icons-ui": "static-1.2418",
  "atom": "static-1.5501",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1147",
  "breeze-artifacts-sdk": "static-1.707",
  "getting-started-shared-tasks": "static-1.19476",
  "onboarding-journeys-lib": "static-1.1153",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.44000",
  "customer-data-filters-ui-msw-helpers": "static-1.23677",
  "events-data-lib": "static-1.671",
  "FormUrlGenerator": "static-2.5137",
  "framework-builder-read-service-client": "static-1.4296",
  "hs-resources": "static-1.621",
  "multi-account-reference-resolvers": "static-1.1427",
  "onboarding-tours": "static-1.17314",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14682",
  "segments-client-types": "static-1.11992",
  "academy-common-lib": "static-1.15329",
  "dashboard-lib": "static-1.83181",
  "hubspot-prosemirror-plugins": "static-1.19182",
  "share-with-third-party-component-lib": "static-1.9134",
  "ui-asset-management-lib": "static-1.11525",
  "user-context": "static-1.5480",
  "reporting-plugins": "static-1.10910",
  "reporting-reports": "static-1.68882",
  "hubs-service-types": "static-1.1689",
  "purchase-motions-api": "static-1.6574",
  "salesImages": "static-1.681",
  "signup-constants": "static-1.19853",
  "nest": "static-1.660",
  "breeze-engine-chat-components": "static-1.1000",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3090",
  "nudge-renderer-utils": "static-1.3409",
  "whisper-core-api": "static-1.7551",
  "bend-plugin-fail-safe": "static-1.328",
  "framework-listing-lib": "static-2.29712",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31661",
  "apps-service-types": "static-1.4071",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8483",
  "onboarding-tours-client": "static-1.5529",
  "one-click-checkout": "static-1.668",
  "platform-infra-nav-components": "static-1.7972",
  "subscription-experience-data-types": "static-1.15375",
  "crm-record-cards-service-types": "static-1.3838",
  "location-customization-utils-lib": "static-1.10331",
  "redux-thunk": "static-2.83",
  "react-flip-move": "static-1.82",
  "ui-coaching-tips": "static-1.29518",
  "content-media-composition-data-lib": "static-1.13495",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4849",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3898",
  "seat-types-lib": "static-1.955",
  "ui-addon-opt": "static-4.8807",
  "commerce-tours-lib": "static-1.6791",
  "growth-onboarding-reliability": "static-1.5506",
  "sales-checkout-service-client": "static-1.3953",
  "data-token-picker": "static-1.17052",
  "FileManagerLib": "static-1.40396",
  "content-media-compositions": "static-2.17502",
  "media-bridge-lib": "static-1.19567",
  "chatspot-widget-iframe": "static-1.23544",
  "collaboration-sidebar-common": "static-1.3755",
  "marketing-platform-lib": "static-1.7317",
  "dnd-kit": "static-1.20",
  "card-properties-lib": "static-1.45232",
  "commerce-subscription-lib": "static-1.38005",
  "crm-actions": "static-1.6774",
  "crm-cards-sdk": "static-1.44887",
  "customer-data-properties-shared-msw-handlers": "static-1.10146",
  "customer-data-tracking": "static-1.7296",
  "calling-global-api": "static-1.66041",
  "calling-internal-common": "static-1.31748",
  "calling-lifecycle-internal": "static-1.67423",
  "calling-lifecycle-messages": "static-1.59716",
  "commerce-products-lib": "static-1.10778",
  "conditional-properties-service-client": "static-1.4089",
  "crm-index-visualization-core": "static-1.4688",
  "crm-links": "static-1.6729",
  "crm-pipelines-api-client-types": "static-1.4420",
  "formula-editor": "static-1.14943",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4499",
  "meetings-icalendar-utils-lib": "static-1.1061",
  "multi-currency-client-types": "static-1.3985",
  "object-builder-ui-client": "static-1.49940",
  "pipeline-validation-client-types": "static-1.4257",
  "smart-data-capture-core": "static-1.369",
  "smart-property-lib": "static-1.8536",
  "tiered-pricing": "static-1.2155",
  "topics-actions-lib": "static-1.599",
  "ui-addon-form-validation": "static-1.11341",
  "zustand": "static-1.88",
  "fdsr-migration-layer": "static-1.434",
  "framework-data-schema-quick-fetch": "static-1.7220",
  "restore-request-side-panel-lib": "static-1.1932",
  "growth-data-modal": "static-1.6060",
  "growth-onboarding-confetti": "static-1.3486",
  "growth-onboarding-next-action-utils": "static-1.2900",
  "onboarding-tours-utils": "static-1.1381",
  "ui-shepherd-tracker": "static-1.8079",
  "crm-index-associations-lib": "static-1.6871",
  "academy-service-client": "static-1.4117",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40255",
  "SafeStorage": "static-1.4817",
  "video-embed": "static-1.36835",
  "redux-actions": "static-3.73",
  "EmailSignatureEditor": "static-1.25169",
  "viral-links-lib": "static-1.7503",
  "nested-table": "static-1.659",
  "timezone-utils": "static-2.5655",
  "getting-started-shared-tasks-store": "static-1.18594",
  "campaign-roi-lib": "static-1.10674",
  "campaigns-utils-lib": "static-1.3658",
  "ui-addon-calendars": "static-2.5787",
  "customer-data-views-management": "static-1.26238",
  "framework-data-table": "static-2.12760",
  "nudge-custom-ui-functions": "static-1.1670",
  "switchboard-lib": "static-1.648",
  "access-check-ui-lib": "static-1.1802",
  "app-users-service-client": "static-1.6042",
  "app-users-service-types": "static-1.5450",
  "mini-checkout-client": "static-1.27763",
  "onboarding-utils": "static-1.5795",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29503",
  "checkout-sdk": "static-3.24606",
  "payment-method-components": "static-1.7269",
  "touchless-buying-components": "static-1.6474",
  "upgrade-catalog-service-types": "static-1.3849",
  "edison-service-client-types": "static-1.817",
  "growth-onboarding-feedback-components": "static-1.7006",
  "audio-components": "static-1.6500",
  "FileManagerImages": "static-1.37907",
  "video-components": "static-1.14345",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93094",
  "customer-data-sidebar": "static-2.46936",
  "enrichment-lib": "static-1.804",
  "ui-addon-draggable-compat": "static-2.4685",
  "universal-record-utils-lib": "static-1.2253",
  "commerce-billing-lib": "static-1.20446",
  "commerce-shared-components-lib": "static-1.19488",
  "commerce-tools-ui-lib": "static-1.11241",
  "crm-fe-perf": "static-1.23320",
  "calling-error-reporting": "static-1.31755",
  "shared-worker-versioning": "static-1.11464",
  "calling-usage-tracker": "static-1.6958",
  "voice-sms-access-library": "static-1.2334",
  "commerce-permissions": "static-1.1203",
  "products-iframe-lib": "static-1.8816",
  "products-ui-components-shared-msw-handlers": "static-1.11201",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10902",
  "sales-views-client-types": "static-1.4682",
  "bark-lib": "static-1.16955",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.821",
  "policy-lib": "static-1.7229",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10965",
  "onboarding-data-sync-lib": "static-1.2763",
  "growth-onboarding-next-action-components": "static-1.2928",
  "user-context-client": "static-1.4933",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4940",
  "outpost": "static-1.4556",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22282",
  "sales-email-signature-service-client": "static-1.4274",
  "ts-utils-lib": "static-1.572",
  "copilot-messaging": "static-1.2309",
  "crm-export-dialog": "static-1.6700",
  "crm-index-ui-shimmer": "static-1.2895",
  "crm-view-components": "static-1.1415",
  "react-beautiful-dnd": "static-1.74",
  "customer-data-associations": "static-1.7755",
  "tasks-actions-lib": "static-1.344",
  "InboxConnectUtils": "static-4.15761",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47059",
  "hub-http-rxjs": "static-1.869",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4414",
  "company-details-components": "static-1.6629",
  "react-performance-metrics-lib": "static-1.974",
  "pricing-pages-ui-components": "static-1.16354",
  "quote-checkout-service-types": "static-1.3880",
  "social-insights-client-types": "static-1.22850",
  "crm_universal": "static-1.22650",
  "customer-data-email": "static-1.18589",
  "card-payment-highlight-lib": "static-1.38210",
  "commerce-contract-lib": "static-1.13669",
  "invoices-highlight-card-lib": "static-1.56067",
  "orders-highlight-card-lib": "static-1.22416",
  "products-highlight-card-lib": "static-1.19061",
  "quotes-highlight-card-lib": "static-1.73003",
  "crm-source-interpretation-lib": "static-1.5751",
  "data-agent-test-utils": "static-1.365",
  "data-agent-utils": "static-1.834",
  "enrichment-settings-lib": "static-1.149",
  "crm-object-search-query-utilities": "static-1.10385",
  "utility-belt": "static-1.2959",
  "payments-enrollment-embed-lib": "static-1.24112",
  "stripe-embedded-components": "static-1.8167",
  "customer-data-rte": "static-1.33820",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6457",
  "payments-post-enroll-local-storage-lib": "static-1.5527",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39093",
  "calling-orchestration-schema": "static-1.37111",
  "react-reducer-toolkit": "static-1.16581",
  "meetings-connect-utils-lib": "static-1.8040",
  "hub-http-contrib": "static-1.3452",
  "ui-addon-sales-email": "static-1.5626",
  "access-control-lib": "static-1.10852",
  "EmailComponents": "static-1.55756",
  "EmailData": "static-1.54434",
  "messaging-base-table-lib": "static-1.717",
  "redux-less": "static-2.9883",
  "company-details-service-types": "static-1.4366",
  "segments-query-core": "static-1.1853",
  "pricing-pages-api": "static-1.16219",
  "sequences-lib": "static-1.8695",
  "ui-gdpr-components": "static-1.10651",
  "products-ui-components": "static-1.41296",
  "reporting-enablement": "static-1.24070",
  "accounting-integrations-ui-components": "static-1.7722",
  "invoices-ui-lib": "static-1.56083",
  "commerce-products-api": "static-1.2847",
  "invoices-iframe-lib": "static-1.58141",
  "quotes-modal-lib": "static-1.103681",
  "quotes-ui-lib": "static-1.81724",
  "stripe-connect-js": "static-1.81",
  "draft-content-plugins": "static-1.29078",
  "ContentComponents": "static-2.72312",
  "ContentData": "static-1.69431",
  "marketing-email-service-types": "static-1.2183",
  "messaging-editing-lib": "static-1.47374",
  "messaging-usage-based-billing-components-lib": "static-1.2236",
  "automation-ui-source-apps": "static-1.19892",
  "automation-ui-types": "static-1.20810",
  "messaging-types-lib": "static-1.47111",
  "onboarding-settings-client": "static-1.4933",
  "sequences-client-types-lib": "static-1.8552",
  "commerce-tax-lib": "static-1.960",
  "price-books-api": "static-1.1943",
  "price-books-components": "static-1.2001",
  "property-description-translator": "static-1.4244",
  "ramp-editor": "static-1.1089",
  "data-quality-ui-library": "static-1.14188",
  "report-customization-components": "static-1.14122",
  "reporting-filters": "static-1.1212",
  "reporting-insights-lib": "static-1.2828",
  "commerce-analytics-service-client": "static-1.3941",
  "totals-ui-components": "static-1.24486",
  "SalesContentIndexUI": "static-3.9692",
  "advanced-menus-core": "static-1.15740",
  "advanced-menus-lib": "static-1.12514",
  "automation-ui-ubb": "static-1.6726",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7763",
  "data-token-views": "static-1.17033",
  "forms-utils-lib": "static-1.13259",
  "payments-embed-points-lib": "static-1.13771",
  "react-tinymce": "static-1.56185",
  "simple-menus-core": "static-1.15739",
  "simple-menus-lib": "static-1.17256",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55311",
  "tinymce-data": "static-1.41396",
  "tinymce-plugins": "static-1.58425",
  "tinymce-themes": "static-1.57281",
  "ui-brand-identity-lib": "static-1.16811",
  "ui-memberships-settings-lib": "static-1.35094",
  "videoconference-integration-components": "static-1.7459",
  "automation-applications-service-types": "static-1.3698",
  "automation-platform-service-types": "static-1.2709",
  "ContentEditorUI": "static-2.78143",
  "content-whatsapp-service-types": "static-1.648",
  "short-messages-app-service-client": "static-1.4349",
  "web-interactives-components": "static-1.14415",
  "web-interactives-data": "static-1.14416",
  "messaging-shared-utils-lib": "static-1.1685",
  "messaging-user-info-utils-lib": "static-1.1855",
  "email-portal-health-service-types": "static-1.1405",
  "line-items-api": "static-1.1258",
  "merge-modal-lib": "static-1.12944",
  "commerce-totals-service-types": "static-1.4108",
  "FireAlarmUi": "static-1.4809",
  "sales-templates-service-types-lib": "static-1.4460",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22746",
  "automation-ui-usage-tracking": "static-1.22209",
  "data-studio-ubb": "static-1.3726",
  "interframe": "static-3.5164",
  "layout-dnd-components": "static-1.13142",
  "layout-dnd-utils": "static-1.12117",
  "NamespacedHubStyle": "static-2.9332",
  "campaigns-lib": "static-1.27825",
  "content-management-data-lib": "static-1.6152",
  "copilot-plugins": "static-1.12031",
  "cta-picker": "static-1.37168",
  "customer-agent-discovery-components-lib": "static-1.4179",
  "editor-components": "static-1.13815",
  "editor-iframe-lib": "static-1.8939",
  "error-messaging-js": "static-1.5559",
  "FormsCommonComponents": "static-1.86756",
  "layout-data-lib": "static-1.10442",
  "pictos": "static-7.194",
  "react-transition-group": "static-2.77",
  "redux-request-state": "static-1.11063",
  "SharedLegalStrings": "static-1.2153",
  "smart-content-core": "static-1.43376",
  "smart-content-lib": "static-1.44029",
  "social-composer-lib": "static-1.60508",
  "structured-content-lib": "static-1.26112",
  "theme-previewer-lib": "static-1.54091",
  "tinymce-copilot": "static-1.17379",
  "xray-recommendation-lib": "static-1.8396",
  "automation-ui-routing": "static-1.22167",
  "sql-reporting-client-types": "static-1.5978",
  "attribution-lib": "static-1.42939",
  "voice-agents-components": "static-1.3994",
  "forms-ai-lib": "static-1.4910",
  "codemirror-dlb": "static-1.59702",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6869",
  "calling-orchestration-shared-library": "static-1.36886"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13429",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1058",
  "client-types": "/client-types/static-1.507",
  "data-fetching-client": "/data-fetching-client/static-1.10070",
  "foundations-components": "/foundations-components/static-1.8670",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1695",
  "foundations-theming": "/foundations-theming/static-1.4905",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.92",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8462",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10819",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11916",
  "I18n": "/I18n/static-7.1696",
  "jasmine-runner": "/jasmine-runner/static-1.6873",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.824",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13492",
  "quartz": "/quartz/static-1.7597",
  "react-dlb": "/react-dlb/static-1.92",
  "react-rhumb": "/react-rhumb/static-1.17157",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3275",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11139",
  "reselect": "/reselect/static-3.15",
  "settings-ui-lib": "/settings-ui-lib/static-1.12954",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7779",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11570",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9953",
  "unified-auth": "/unified-auth/static-1.1148",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1430",
  "usage-tracker": "/usage-tracker/static-1.7738",
  "usage-tracker-core": "/usage-tracker-core/static-1.7588",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8468",
  "hub-http": "/hub-http/static-1.6633",
  "integrations-lib": "/integrations-lib/static-1.17314",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20967",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.953",
  "property-management-iframe": "/property-management-iframe/static-1.14367",
  "quartz-config": "/quartz-config/static-1.1375",
  "quartz-core": "/quartz-core/static-1.6816",
  "quartz-routing": "/quartz-routing/static-1.1027",
  "quick-fetch": "/quick-fetch/static-1.4199",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5094",
  "ts-schema": "/ts-schema/static-1.4369",
  "ui-universal-auth": "/ui-universal-auth/static-1.9634",
  "UIComponents": "/UIComponents/static-3.8862",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3874",
  "quartz-webpack": "/quartz-webpack/static-1.3821",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.675",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9936",
  "codemirror": "/codemirror/static-5.105",
  "foundations-assets": "/foundations-assets/static-1.5308",
  "pulse": "/pulse/static-1.1065",
  "react-codemirror": "/react-codemirror/static-1.11064",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.844",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4939",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2621",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9848",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.94",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5631",
  "react-virtualized": "/react-virtualized/static-2.111",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2967",
  "ui-fonts": "/ui-fonts/static-1.1178",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3388",
  "foundations-theming-base": "/foundations-theming-base/static-1.3890",
  "stylex": "/stylex/static-1.45",
  "HeadJS": "/HeadJS/static-2.815",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3573",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.23",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4732",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ai-rendering-library": "/ai-rendering-library/static-1.11320",
  "chirp-fetch": "/chirp-fetch/static-1.2325",
  "connections-embed-lib": "/connections-embed-lib/static-1.1672",
  "copilot-toolkit": "/copilot-toolkit/static-1.12059",
  "feedback-loader": "/feedback-loader/static-1.29986",
  "laboratory-lib": "/laboratory-lib/static-3.7573",
  "marketplace-embed": "/marketplace-embed/static-1.23116",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10862",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20922",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15137",
  "sanitize-text": "/sanitize-text/static-1.8580",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6152",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5424",
  "wootric-nps": "/wootric-nps/static-1.7270",
  "quartz-head": "/quartz-head/static-1.1262",
  "web-vitals": "/web-vitals/static-1.18",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4565",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2788",
  "reporting-data": "/reporting-data/static-1.69206",
  "cssUtils": "/cssUtils/static-1.1046",
  "flux-actions": "/flux-actions/static-1.380",
  "react-colorpicker": "/react-colorpicker/static-2.10636",
  "react-dnd-compat": "/react-dnd-compat/static-1.5034",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10795",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7728",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19499",
  "storybook-react": "/storybook-react/static-1.43",
  "trellis-story-utils": "/trellis-story-utils/static-1.4926",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6153",
  "quartz-i18n": "/quartz-i18n/static-1.1272",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.676",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1783",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.198",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1244",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.405",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.772",
  "slack-ui-library": "/slack-ui-library/static-1.10821",
  "fsm": "/fsm/static-1.4179",
  "customer-data-objects": "/customer-data-objects/static-1.8117",
  "property-translator": "/property-translator/static-1.5803",
  "hs-locale-management": "/hs-locale-management/static-1.368",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8342",
  "hs-promise-utils": "/hs-promise-utils/static-1.6013",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5301",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14729",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6035",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8186",
  "sanitize": "/sanitize/static-1.4897",
  "superstore": "/superstore/static-1.5182",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10698",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8504",
  "hub-http-janus": "/hub-http-janus/static-1.900",
  "hubspotter-http": "/hubspotter-http/static-1.4936",
  "immutable-less": "/immutable-less/static-1.5074",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18374",
  "nav-meta": "/nav-meta/static-1.30713",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18515",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1449",
  "ai-studio-lib": "/ai-studio-lib/static-1.12660",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19190",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.645",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9500",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-product-approvals": "/ui-product-approvals/static-1.29554",
  "ui-tool-access": "/ui-tool-access/static-1.10579",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4116",
  "property-management-common": "/property-management-common/static-1.6655",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.212",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.598",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.587",
  "quartz-auth": "/quartz-auth/static-1.1272",
  "quartz-test": "/quartz-test/static-1.1272",
  "quartz-tracking": "/quartz-tracking/static-1.976",
  "trellis-components": "/trellis-components/static-1.2986",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.504",
  "HubStyle": "/HubStyle/static-2.12223",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23553",
  "ContentUtils": "/ContentUtils/static-1.69356",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13454",
  "sassPrefix": "/sassPrefix/static-1.312",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.568",
  "batch-promise": "/batch-promise/static-1.1970",
  "event-emitter": "/event-emitter/static-1.1383",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5860",
  "magpie-types": "/magpie-types/static-1.5320",
  "stylex-utils": "/stylex-utils/static-1.164",
  "trellis-theming": "/trellis-theming/static-1.1409",
  "avatar-components": "/avatar-components/static-1.2907",
  "breeze-engine-core": "/breeze-engine-core/static-1.1300",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.971",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41242",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13591",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.212",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15869",
  "ExportDialog": "/ExportDialog/static-6.10795",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.408",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.819",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42282",
  "reporting-snowflake": "/reporting-snowflake/static-1.57822",
  "reporting-ui-components": "/reporting-ui-components/static-2.66475",
  "reporting-visualizations": "/reporting-visualizations/static-1.61280",
  "trial-components-library": "/trial-components-library/static-1.14299",
  "ui-addon-teams": "/ui-addon-teams/static-1.21969",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.662",
  "navigation-components": "/navigation-components/static-1.19076",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2022",
  "simple-logging-lib": "/simple-logging-lib/static-1.3475",
  "nudge-client-utils": "/nudge-client-utils/static-1.3333",
  "fail-safe": "/fail-safe/static-1.377",
  "app-governance-lib": "/app-governance-lib/static-1.2596",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10962",
  "purchase-motions-components": "/purchase-motions-components/static-1.6571",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10648",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6155",
  "usage-tracker-public": "/usage-tracker-public/static-1.7549",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3746",
  "persist-promise": "/persist-promise/static-1.4127",
  "reference-resolvers": "/reference-resolvers/static-1.8601",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4339",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.760",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3433",
  "final-form": "/final-form/static-1.82",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "simple-data-table": "/simple-data-table/static-1.3743",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6876",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5171",
  "content-assistance-lib": "/content-assistance-lib/static-1.8351",
  "content-media-capture": "/content-media-capture/static-1.5691",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10257",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24756",
  "growth-payments-core": "/growth-payments-core/static-1.26411",
  "knowledge-content-types": "/knowledge-content-types/static-1.8708",
  "PatternValidationJS": "/PatternValidationJS/static-1.3310",
  "payment-link-components": "/payment-link-components/static-1.24356",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20480",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10290",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9518",
  "video-components-external": "/video-components-external/static-1.12343",
  "video-data-lib": "/video-data-lib/static-1.36001",
  "navigation-messaging": "/navigation-messaging/static-1.8403",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58958",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.467",
  "crm-component-utils": "/crm-component-utils/static-1.40073",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6312",
  "customer-data-properties": "/customer-data-properties/static-1.52903",
  "external-options-client-types": "/external-options-client-types/static-1.4417",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7315",
  "property-value-citations": "/property-value-citations/static-1.3517",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8529",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.123",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10817",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "cms-field-types": "/cms-field-types/static-1.5236",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "atom": "/atom/static-1.5501",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1147",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.707",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19476",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.44000",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23677",
  "events-data-lib": "/events-data-lib/static-1.671",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5137",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4296",
  "hs-resources": "/hs-resources/static-1.621",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1427",
  "onboarding-tours": "/onboarding-tours/static-1.17314",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14682",
  "segments-client-types": "/segments-client-types/static-1.11992",
  "academy-common-lib": "/academy-common-lib/static-1.15329",
  "dashboard-lib": "/dashboard-lib/static-1.83181",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19182",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9134",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11525",
  "user-context": "/user-context/static-1.5480",
  "reporting-plugins": "/reporting-plugins/static-1.10910",
  "reporting-reports": "/reporting-reports/static-1.68882",
  "hubs-service-types": "/hubs-service-types/static-1.1689",
  "purchase-motions-api": "/purchase-motions-api/static-1.6574",
  "salesImages": "/salesImages/static-1.681",
  "signup-constants": "/signup-constants/static-1.19853",
  "nest": "/nest/static-1.660",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1000",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3090",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3409",
  "whisper-core-api": "/whisper-core-api/static-1.7551",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.328",
  "framework-listing-lib": "/framework-listing-lib/static-2.29712",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31661",
  "apps-service-types": "/apps-service-types/static-1.4071",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8483",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5529",
  "one-click-checkout": "/one-click-checkout/static-1.668",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7972",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15375",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3838",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10331",
  "redux-thunk": "/redux-thunk/static-2.83",
  "react-flip-move": "/react-flip-move/static-1.82",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29518",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13495",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4849",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3898",
  "seat-types-lib": "/seat-types-lib/static-1.955",
  "ui-addon-opt": "/ui-addon-opt/static-4.8807",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6791",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5506",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3953",
  "data-token-picker": "/data-token-picker/static-1.17052",
  "FileManagerLib": "/FileManagerLib/static-1.40396",
  "content-media-compositions": "/content-media-compositions/static-2.17502",
  "media-bridge-lib": "/media-bridge-lib/static-1.19567",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23544",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3755",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7317",
  "dnd-kit": "/dnd-kit/static-1.20",
  "card-properties-lib": "/card-properties-lib/static-1.45232",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38005",
  "crm-actions": "/crm-actions/static-1.6774",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44887",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10146",
  "customer-data-tracking": "/customer-data-tracking/static-1.7296",
  "calling-global-api": "/calling-global-api/static-1.66041",
  "calling-internal-common": "/calling-internal-common/static-1.31748",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67423",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59716",
  "commerce-products-lib": "/commerce-products-lib/static-1.10778",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4089",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4688",
  "crm-links": "/crm-links/static-1.6729",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4420",
  "formula-editor": "/formula-editor/static-1.14943",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4499",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1061",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3985",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49940",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4257",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.369",
  "smart-property-lib": "/smart-property-lib/static-1.8536",
  "tiered-pricing": "/tiered-pricing/static-1.2155",
  "topics-actions-lib": "/topics-actions-lib/static-1.599",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
  "zustand": "/zustand/static-1.88",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.434",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7220",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1932",
  "growth-data-modal": "/growth-data-modal/static-1.6060",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3486",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2900",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1381",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8079",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6871",
  "academy-service-client": "/academy-service-client/static-1.4117",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40255",
  "SafeStorage": "/SafeStorage/static-1.4817",
  "video-embed": "/video-embed/static-1.36835",
  "redux-actions": "/redux-actions/static-3.73",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25169",
  "viral-links-lib": "/viral-links-lib/static-1.7503",
  "nested-table": "/nested-table/static-1.659",
  "timezone-utils": "/timezone-utils/static-2.5655",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18594",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10674",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3658",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5787",
  "customer-data-views-management": "/customer-data-views-management/static-1.26238",
  "framework-data-table": "/framework-data-table/static-2.12760",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1670",
  "switchboard-lib": "/switchboard-lib/static-1.648",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1802",
  "app-users-service-client": "/app-users-service-client/static-1.6042",
  "app-users-service-types": "/app-users-service-types/static-1.5450",
  "mini-checkout-client": "/mini-checkout-client/static-1.27763",
  "onboarding-utils": "/onboarding-utils/static-1.5795",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29503",
  "checkout-sdk": "/checkout-sdk/static-3.24606",
  "payment-method-components": "/payment-method-components/static-1.7269",
  "touchless-buying-components": "/touchless-buying-components/static-1.6474",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3849",
  "edison-service-client-types": "/edison-service-client-types/static-1.817",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7006",
  "audio-components": "/audio-components/static-1.6500",
  "FileManagerImages": "/FileManagerImages/static-1.37907",
  "video-components": "/video-components/static-1.14345",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93094",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46936",
  "enrichment-lib": "/enrichment-lib/static-1.804",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4685",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2253",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20446",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19488",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11241",
  "crm-fe-perf": "/crm-fe-perf/static-1.23320",
  "calling-error-reporting": "/calling-error-reporting/static-1.31755",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11464",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6958",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2334",
  "commerce-permissions": "/commerce-permissions/static-1.1203",
  "products-iframe-lib": "/products-iframe-lib/static-1.8816",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11201",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10902",
  "sales-views-client-types": "/sales-views-client-types/static-1.4682",
  "bark-lib": "/bark-lib/static-1.16955",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.821",
  "policy-lib": "/policy-lib/static-1.7229",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10965",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2763",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2928",
  "user-context-client": "/user-context-client/static-1.4933",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4940",
  "outpost": "/outpost/static-1.4556",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22282",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4274",
  "ts-utils-lib": "/ts-utils-lib/static-1.572",
  "copilot-messaging": "/copilot-messaging/static-1.2309",
  "crm-export-dialog": "/crm-export-dialog/static-1.6700",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2895",
  "crm-view-components": "/crm-view-components/static-1.1415",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
  "customer-data-associations": "/customer-data-associations/static-1.7755",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.344",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15761",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47059",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.869",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4414",
  "company-details-components": "/company-details-components/static-1.6629",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.974",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16354",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3880",
  "social-insights-client-types": "/social-insights-client-types/static-1.22850",
  "crm_universal": "/crm_universal/static-1.22650",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38210",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13669",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56067",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22416",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19061",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.73003",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5751",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.365",
  "data-agent-utils": "/data-agent-utils/static-1.834",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.149",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10385",
  "utility-belt": "/utility-belt/static-1.2959",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24112",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8167",
  "customer-data-rte": "/customer-data-rte/static-1.33820",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6457",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5527",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39093",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37111",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16581",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8040",
  "hub-http-contrib": "/hub-http-contrib/static-1.3452",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5626",
  "access-control-lib": "/access-control-lib/static-1.10852",
  "EmailComponents": "/EmailComponents/static-1.55756",
  "EmailData": "/EmailData/static-1.54434",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.717",
  "redux-less": "/redux-less/static-2.9883",
  "company-details-service-types": "/company-details-service-types/static-1.4366",
  "segments-query-core": "/segments-query-core/static-1.1853",
  "pricing-pages-api": "/pricing-pages-api/static-1.16219",
  "sequences-lib": "/sequences-lib/static-1.8695",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "products-ui-components": "/products-ui-components/static-1.41296",
  "reporting-enablement": "/reporting-enablement/static-1.24070",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7722",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56083",
  "commerce-products-api": "/commerce-products-api/static-1.2847",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58141",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103681",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81724",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "draft-content-plugins": "/draft-content-plugins/static-1.29078",
  "ContentComponents": "/ContentComponents/static-2.72312",
  "ContentData": "/ContentData/static-1.69431",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2183",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47374",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2236",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19892",
  "automation-ui-types": "/automation-ui-types/static-1.20810",
  "messaging-types-lib": "/messaging-types-lib/static-1.47111",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4933",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8552",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.960",
  "price-books-api": "/price-books-api/static-1.1943",
  "price-books-components": "/price-books-components/static-1.2001",
  "property-description-translator": "/property-description-translator/static-1.4244",
  "ramp-editor": "/ramp-editor/static-1.1089",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14188",
  "report-customization-components": "/report-customization-components/static-1.14122",
  "reporting-filters": "/reporting-filters/static-1.1212",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2828",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3941",
  "totals-ui-components": "/totals-ui-components/static-1.24486",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9692",
  "advanced-menus-core": "/advanced-menus-core/static-1.15740",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12514",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6726",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7763",
  "data-token-views": "/data-token-views/static-1.17033",
  "forms-utils-lib": "/forms-utils-lib/static-1.13259",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13771",
  "react-tinymce": "/react-tinymce/static-1.56185",
  "simple-menus-core": "/simple-menus-core/static-1.15739",
  "simple-menus-lib": "/simple-menus-lib/static-1.17256",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55311",
  "tinymce-data": "/tinymce-data/static-1.41396",
  "tinymce-plugins": "/tinymce-plugins/static-1.58425",
  "tinymce-themes": "/tinymce-themes/static-1.57281",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16811",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35094",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7459",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3698",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2709",
  "ContentEditorUI": "/ContentEditorUI/static-2.78143",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.648",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4349",
  "web-interactives-components": "/web-interactives-components/static-1.14415",
  "web-interactives-data": "/web-interactives-data/static-1.14416",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1685",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1855",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1405",
  "line-items-api": "/line-items-api/static-1.1258",
  "merge-modal-lib": "/merge-modal-lib/static-1.12944",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4108",
  "FireAlarmUi": "/FireAlarmUi/static-1.4809",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4460",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22746",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22209",
  "data-studio-ubb": "/data-studio-ubb/static-1.3726",
  "interframe": "/interframe/static-3.5164",
  "layout-dnd-components": "/layout-dnd-components/static-1.13142",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12117",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9332",
  "campaigns-lib": "/campaigns-lib/static-1.27825",
  "content-management-data-lib": "/content-management-data-lib/static-1.6152",
  "copilot-plugins": "/copilot-plugins/static-1.12031",
  "cta-picker": "/cta-picker/static-1.37168",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4179",
  "editor-components": "/editor-components/static-1.13815",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8939",
  "error-messaging-js": "/error-messaging-js/static-1.5559",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86756",
  "layout-data-lib": "/layout-data-lib/static-1.10442",
  "pictos": "/pictos/static-7.194",
  "react-transition-group": "/react-transition-group/static-2.77",
  "redux-request-state": "/redux-request-state/static-1.11063",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2153",
  "smart-content-core": "/smart-content-core/static-1.43376",
  "smart-content-lib": "/smart-content-lib/static-1.44029",
  "social-composer-lib": "/social-composer-lib/static-1.60508",
  "structured-content-lib": "/structured-content-lib/static-1.26112",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54091",
  "tinymce-copilot": "/tinymce-copilot/static-1.17379",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8396",
  "automation-ui-routing": "/automation-ui-routing/static-1.22167",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5978",
  "attribution-lib": "/attribution-lib/static-1.42939",
  "voice-agents-components": "/voice-agents-components/static-1.3994",
  "forms-ai-lib": "/forms-ai-lib/static-1.4910",
  "codemirror-dlb": "/codemirror-dlb/static-1.59702",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6869",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36886"
}
};
